import { getOptionsProvider } from '@shared/OptionsProvider';
import type { D3Country } from '@utilities/country';

export type PlaymakersOptions = {
  acceptedLanguages: string[];
  countries: D3Country[];
  activeCountries: Record<string, string>;
  excludedCountries: Record<string, string>;
  rootingBaseUrl: string;
};

export const { OptionsProvider: PlaymakersOptionsProvider, useOptions: usePlaymakersOptions } =
  getOptionsProvider<PlaymakersOptions>();
